var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    stroke: "#fff",
    d: "M9 11.107A3.11 3.11 0 0 1 5.892 8 3.11 3.11 0 0 1 9 4.891a3.11 3.11 0 0 1 3.108 3.108A3.11 3.11 0 0 1 9 11.107Zm0-5.966a2.862 2.862 0 0 0-2.858 2.858A2.862 2.862 0 0 0 9 10.857 2.862 2.862 0 0 0 11.858 8 2.862 2.862 0 0 0 9 5.141Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    stroke: "#fff",
    d: "M1.296 10.232v-.001C.916 9.64.712 8.837.712 8.004c0-.832.205-1.64.584-2.233C3.27 2.695 6.084.984 9 .984c2.916 0 5.731 1.711 7.695 4.786v.001c.38.59.584 1.395.584 2.227 0 .832-.204 1.64-.584 2.234-1.964 3.075-4.779 4.786-7.695 4.786-2.925 0-5.74-1.711-7.704-4.786ZM9 1.234c-2.905 0-5.622 1.744-7.488 4.673C1.134 6.497.964 7.267.964 8c0 .735.17 1.504.548 2.094C3.378 13.024 6.095 14.768 9 14.768c2.905 0 5.622-1.744 7.488-4.673.378-.59.547-1.359.547-2.094 0-.735-.17-1.504-.547-2.094C14.622 2.978 11.905 1.234 9 1.234Z"
  })));
};
export default SvgIconEye;